import styled from 'styled-components';

import { VerticalHorizontalCenterColumnBlock } from '../../../../styled';

export const UserInformation = styled.p`
  ${(props) => props.theme.typography.descriptionCompact};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 16px;
`;

export const UserNameTitle = styled.h1`
  ${(props) => props.theme.typography.title2compact};
  margin-bottom: 16px;
`;

export const NicknameWrapper = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChangeServerCustomIdWrapper = styled.div`
  padding-top: 20px;
`;

export const NoDataContentBox = styled(VerticalHorizontalCenterColumnBlock)`
  min-height: 170px;
  color: ${(props) => props.theme.colors.muted};
  font-style: italic;
`;

export const LoginHistoryTableWrapper = styled.div`
  margin-top: 16px;
  margin-left: 32px;
  margin-right: -100px;
  p {
    margin: 0;
  }
`;

export const PaginationWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
